import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "HotRecommend",
    serverType: "hot_questions",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "HotRecommend",
            items: [
                {
                    uId: uniqueId(),
                    wtType: "HotEditItem",
                    updateState: "add"
                },
                {
                    uId: uniqueId(),
                    wtType: "HotEditItem",
                    updateState: "add"
                }
            ]
        };
    },
    initItem(item) {
        return {
            uId: uniqueId(),
            wtType: item.type,
            updateState: "add"
        };
    },
    checkContent(content) {
        content.items.forEach(item => {
            if (!item.hotTitle) {
                throw new ParamError(i18n.t("zhiji.answer.hotTitleTip"));
            }

            if (!item.questionId) {
                throw new ParamError(i18n.t("zhiji.answer.linkQuestion"));
            }
        });
    },
    server2Client(content) {
        return {
            uId: uniqueId(),
            wtType: "HotRecommend",
            items: cvtHotItemClient(content),
            updateState: ""
        };
    },
    client2Server(content) {
        return {
            type: "hot_questions",
            content: [
                {
                    id: "", //暂时无用，默认为空
                    title: "", //暂时无用，默认为空
                    questions: cvtHotItemParams(content)
                }
            ]
        };
    }
};

// 热点每个子项参数转换
function cvtHotItemParams(itemParams) {
    let serveParams = [];
    serveParams = itemParams.items.map(item => {
        return {
            type: "question",
            question: item.question,
            question_id: item.questionId,
            question_display_text: item.hotTitle
        };
    });

    return serveParams;
}

// 热点子项客户端数据
function cvtHotItemClient(data) {
    let hotQuestions = data.content[0] && data.content[0].questions;
    let result = [];
    result = hotQuestions.map(item => {
        return {
            questionId: item.question_id,
            question: item.question,
            hotTitle: item.question_display_text,
            uId: uniqueId(),
            wtType: "HotEditItem",
            updateState: "add"
        };
    });

    return result;
}
